import { Box } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import React, { useRef, useState } from "react";
import ContentEditable from "react-contenteditable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import JoinIyugaButton from "../../assets/images/join-iyuga.svg";
import { FROALA_FOCUS_ENUM } from "../../constants/FroalaFocus.enum";
import useScreenSize from "../../hooks/useScreenSize";
import {
  handleFroalaFocus,
  handleMenuChange,
} from "../../redux/reducers/segmentBuilder";
import {
  getWheelIsClonableValue,
  getWheelIsDraftValue,
  getWheelIsLiveValue,
} from "../../redux/selectors/segmentBuilderSelectors";
import { ASSETS } from "../../utils/config";
import { isUserLoggedIn, transformEditorText } from "../../utils/helpers";
import { EnterBetaButton } from "../EnterBetaButton";
import IyugaTooltip from "../IyugaTooltip";
import BroadCastButton from "../LiveCloneComponents/BroadCastButton";
import ActionsDropdown from "../MobileView/ActionsDropdown";
import ProfileMenu from "../ProfileMenu";
import SearchBar from "../SearchBar";
import WheelAuthor from "../SegmentBuilder/Shared/WheelAuthor";
import TextView from "../TextView";
import "./field.scss";
import * as Styled from "./styles";

function WheelHeader({
  rightContent = [],
  leftContent = [],
  wheelId,
  wheelName,
  subtitle,
  disabled = false,
  isCloned,
  setModalOpen = null,
  setOnLeave = null,
  selectedArc,
  handleCloneWheel,
  handleLikeUnlike,
  isLiked,
  handleShare,
  onClickBeta,
  onBroadCastPress,
  showBroadCastButton = false,
  handleLogoClick,
  isEditScreen = false,
  navigateToSignup,
}) {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [openSearch, setOpenSearch] = useState(false);
  const { isMobileLandscape } = useScreenSize();

  const [showAuthorInfo, setShowAuthorInfo] = useState(false);

  const wheelInformation = useSelector((state) => state.segmentBuilder);
  const prevIndexRef = useRef(wheelInformation?.currentIndex);
  const isWheelClonable = useSelector(getWheelIsClonableValue);
  const isWheelLive = useSelector(getWheelIsLiveValue);
  const isdraft = useSelector(getWheelIsDraftValue);
  const currentUrl = window.location.href;

  const [actionsModalOpen, setActionsModalOpen] = useState(false);

  return (
    <Styled.HeaderMainDiv
      isMobileLandscape={isMobileLandscape}
      hide={selectedArc}
    >
      {isMobileLandscape && openSearch ? (
        <>
          <div style={{ marginRight: 16, width: 45, height: 45 }}>
            <Styled.Icon
              src={ASSETS.iyugaBetaLogo}
              alt="Iyuga logo"
              onClick={handleLogoClick}
            />
          </div>
          <SearchBar />
          <TextView
            variant="subtitle"
            onClick={() => setOpenSearch(false)}
            style={{ marginLeft: 10 }}
          >
            Cancel
          </TextView>
        </>
      ) : (
        <>
          <Styled.LeftContainer>
            <Tooltip title="Back to Gallery">
              <Styled.Icon
                src={ASSETS.iyugaBetaLogo}
                alt="Iyuga logo"
                onClick={handleLogoClick}
              />
            </Tooltip>

            {leftContent.map((item) => (
              <Tooltip title={item.tooltip} key={item.tooltip}>
                <Styled.IconWrapper
                  boolean={item.boolean}
                  key={item.id}
                  onClick={item.onClick}
                >
                  {item.icon}
                </Styled.IconWrapper>
              </Tooltip>
            ))}
            {/* <Tooltip title="Search">
              <Styled.IconWrapper>
                <Search fill="#000" onClick={() => setOpenSearch(true)} />
              </Styled.IconWrapper>
            </Tooltip> */}
            {/* <SearchBar  setModalOpen={setModalOpen} setOnLeave={setOnLeave} /> */}
          </Styled.LeftContainer>

          <Styled.Row style={{ gap: 5 }}>
            <Styled.TitleDiv>
              <Styled.Row
                onClick={() => {
                  dispatch(handleMenuChange({ num: 1 }));
                  dispatch(handleFroalaFocus(FROALA_FOCUS_ENUM.TITLE));
                }}
              >
                <TextView
                  variant="subtitle"
                  style={{ textAlign: "center", WebkitLineClamp: 1 }}
                >
                  <ContentEditable
                    html={transformEditorText(wheelName)}
                    disabled
                  />
                </TextView>

                {wheelId && isCloned && (
                  <Styled.AuthorContainer>
                    <img
                      alt="something"
                      src={ASSETS.segmentEditor.BookIcon}
                      style={{ marginLeft: 10, cursor: "pointer" }}
                      onClick={() => setShowAuthorInfo(!showAuthorInfo)}
                    />
                    {showAuthorInfo && (
                      <WheelAuthor
                        wheelId={wheelId}
                        style={{ backgroundColor: "white" }}
                        onClose={() => setShowAuthorInfo(false)}
                      />
                    )}
                  </Styled.AuthorContainer>
                )}
              </Styled.Row>

              <TextView
                variant="subtitle"
                style={{ textAlign: "center", WebkitLineClamp: 1 }}
                onClick={() => {
                  dispatch(handleMenuChange({ num: 1 }));
                  dispatch(handleFroalaFocus(FROALA_FOCUS_ENUM.SUBTITLE));
                }}
              >
                <ContentEditable
                  html={transformEditorText(subtitle)}
                  disabled
                />
              </TextView>
            </Styled.TitleDiv>
            {isMobileLandscape && !isEditScreen && (
              <ActionsDropdown
                setModalOpen={setActionsModalOpen}
                setOnLeave={() => {}}
                onClone={handleCloneWheel}
                onLike={handleLikeUnlike}
                onShare={handleShare}
                isLiked={isLiked}
              />
            )}
          </Styled.Row>

          <Styled.RightContainer>
            <div
              style={{ marginLeft: 16, display: "flex", alignItems: "center" }}
            >
              {showBroadCastButton && isWheelLive && (
                <IyugaTooltip
                  tooltip={
                    !isdraft
                      ? "Sync Clones are up-to-date"
                      : "Synchronize: Update all Sync Clones of this Wheel to the current version and notify their owners."
                  }
                >
                  <BroadCastButton
                    isdraft={isdraft}
                    onPress={onBroadCastPress}
                  ></BroadCastButton>
                </IyugaTooltip>
              )}
              {rightContent.map((item) => (
                <Tooltip key={item.tooltip} title={item.tooltip}>
                  <Styled.IconWrapper
                    boolean={item.boolean}
                    key={item.id}
                    onClick={item.disabled ? undefined : item.onClick}
                    tooltip={item.tooltip} // Pass tooltip as a prop
                    // width={item.isLoading && item?.tooltip === 'Save' ? '100px' : '42px'}
                    width={"42px"}
                    disabled={item.disabled}
                    style={{
                      opacity: item.disabled ? 0.5 : 1,
                      cursor: item.disabled ? "not-allowed" : "pointer",
                    }}
                  >
                    {item?.tooltip === "Save" ||
                    item?.title === "Save Wheel" ? (
                      <img
                        src={
                          item?.disabled
                            ? ASSETS.SaveError
                            : item?.unsavedChanges
                            ? ASSETS.UnsavedChanges
                            : item?.isAutoSaveError
                            ? ASSETS.SaveError
                            : item?.isLoading
                            ? ASSETS.Saving
                            : ASSETS.OnlySave
                        }
                        style={{ height: "35px", width: "35px" }}
                        alt="saving"
                      />
                    ) : item.isLoading ? (
                      <BounceLoader size={24} color="rgb(239,153,113)" />
                    ) : (
                      item.icon
                    )}
                  </Styled.IconWrapper>
                </Tooltip>
              ))}

              {!currentUrl.includes("builder") ? (
                isUserLoggedIn() ? (
                  <EnterBetaButton onClickBeta={onClickBeta} />
                ) : (
                  <EnterBetaButton
                    button={JoinIyugaButton}
                    onlyInvite={true}
                    onClickBeta={navigateToSignup}
                  />
                )
              ) : (
                <Box style={{ width: "15px", height: "20px" }}></Box>
              )}

              <ProfileMenu
                setModalOpen={setModalOpen}
                setOnLeave={setOnLeave}
                onClickBeta={onClickBeta}
              />
            </div>
          </Styled.RightContainer>
        </>
      )}
    </Styled.HeaderMainDiv>
  );
}

export default WheelHeader;
